import React from 'react';
import { avatars } from '@99designs/emu/settings';

interface Props {
    size?: avatars.size | 'fluid';
    title?: string;
}

const AvatarPlaceholder = ({ size = avatars.size.Small, title }: Props) => {
    const sizePx = (size === 'fluid' ? avatars.sizes[avatars.size.Small] : avatars.sizes[size])
        .avatarSize;
    const radius = Math.floor(sizePx / 2);
    return (
        <svg
            viewBox={`0 0 ${sizePx} ${sizePx}`}
            className={`avatar-placeholder avatar-placeholder__${size}`}
        >
            {title && <title>{title}</title>}
            <circle
                cx={radius}
                cy={radius}
                r={radius - 1}
                fill="none"
                strokeWidth="2"
                strokeDasharray="5,4"
                vectorEffect="non-scaling-stroke"
            />
            <text x={radius} y={radius} textAnchor="middle" dy="0.4em">
                
            </text>
        </svg>
    );
};

export default AvatarPlaceholder;
